import React from "react";
import {Divider} from "components/atoms";
import {Layout, TermsPrivacy} from "components/organisms";

export default function Privacy(){
    return (
        <>
            <Layout
                header={{use: true, logo: false, back: false, close: true, util: false, title: '차란차 개인정보 처리방침'}}
                container={{use: true}}
            >
                <Divider>
                    <TermsPrivacy />
                </Divider>
            </Layout>
        </>
    )
}